const VideoJumbotronActionTypes = {
	REQUEST_CONFIG: 'VideoJumbotronRequestConfig',
};

export default VideoJumbotronActionTypes;
